import { connect, MapStateToProps } from 'react-redux';
import { getTierCount } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { Props } from './BasePageLayout';
import { AppState } from '../../../../types/store';
import { getCurrentFeedType, getLayout } from '../../../../selectors/page';

export type StateProps = Pick<Props, 'feedType' | 'hasTiers' | 'layout'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  feedType: getCurrentFeedType(state),
  hasTiers: getTierCount(state) > 0,
  layout: getLayout(state),
});

export default connect(mapStateToProps);
